import React from 'react';
import { Button, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import type { HistoryOrderEntity } from 'types/dto/order';
import './HistoryCell.scss';
import OrderStatusTag from 'components/orderStatusTag/OrderStatusTag';
import { DATETIME_MM_DD_FORMAT } from 'constants/consts';

interface HistoryCellProps {
  order: HistoryOrderEntity;
  onViewDetails: (orderId: string) => void;
}
const HistoryCell: React.FC<HistoryCellProps> = ({ order, onViewDetails }) => {
  const { t } = useTranslation('order_history');

  const formatDateRange = (startDate?: string, endDate?: string) => {
    if (!startDate) return '';
    const start = dayjs(startDate).format(DATETIME_MM_DD_FORMAT);
    if (!endDate) return start;
    const endTime = dayjs(endDate).format('HH:mm');
    return `${start} - ${endTime}`;
  };

  const handleViewDetails = () => {
    onViewDetails(String(order.oph_id));
  };

  return (
    <div className="history-cell-container">
      <Row className="history-cell-header">
        <Col xs={24} sm={{ flex: 'none' }} className="order-number">
          {t('order')} #{order.oph_regnum}
        </Col>
        <Col xs={24} sm={{ flex: 'none' }}>
          <OrderStatusTag status={order.oph_sts} statusName={order.sts_nam} />
        </Col>
      </Row>

      <Row>
        <Col xs={24} sm={14}>
          <Row className="detail-row">
            <Col xs={24} sm={12} className="detail-label">
              {t('collectionDate')}
            </Col>
            <Col xs={24} sm={12}>
              {formatDateRange(order.oph_colstrdtm, order.oph_colenddtm)}
            </Col>
          </Row>
          <Row className="detail-row">
            <Col xs={24} sm={12} className="detail-label">
              {t('deliveryDate')}
            </Col>
            <Col xs={24} sm={12}>
              {formatDateRange(order.oph_delstrdtm, order.oph_delenddtm)}
            </Col>
          </Row>
          <Row className="detail-row">
            <Col xs={24} sm={12} className="detail-label">
              {t('remarks')}
            </Col>
            <Col xs={24} sm={12}>
              {order.oph_rmktocus || ''}
            </Col>
          </Row>
        </Col>
        <Col className="button-column" flex={'auto'}>
          <Button
            type="primary"
            ghost
            className="view-details-button"
            onClick={handleViewDetails}
          >
            {t('viewDetails')}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default HistoryCell;
